import { render, staticRenderFns } from "./AddTransporter.vue?vue&type=template&id=2f92effd"
import script from "./AddTransporter.vue?vue&type=script&lang=js"
export * from "./AddTransporter.vue?vue&type=script&lang=js"
import style0 from "./AddTransporter.vue?vue&type=style&index=0&id=2f92effd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports